import {MimeType,UUID} from '../utils/utils';

export class Document {
  /**
   * The GUID/UUID
   */
  private readonly guid: UUID;
  /**
   * The MIME type
   */
  private readonly mimeType: MimeType;

  constructor(guid: UUID, mimeType: MimeType) {
    this.guid = guid;
    this.mimeType = mimeType;
  }

  public getGuid(): UUID {
    return this.guid;
  }

  public getMimeType(): MimeType {
    return this.mimeType;
  }
}
